import React, { useState, useEffect, useCallback } from "react";
import axiosInstance from "../axiosConfig";
import WIPHeader from "../components/WIP-Herder";
import DataTable from "react-data-table-component";

const RMShortage = () => {
  const [shortageData, setShortageData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");


    // ** Check Session & Redirect if Not Authenticated **
    const checkAuth = useCallback(() => {
      const authData = sessionStorage.getItem("auth");
      if (!authData) {
        window.location.href = "/wip-login"; // Redirect to login
        return;
      }
  
      const { loggedIn, expiryTime } = JSON.parse(authData);
      if (!loggedIn || Date.now() > expiryTime) {
        sessionStorage.removeItem("auth"); // Clear session
        window.location.href = "/wip-login"; // Redirect to login
      }
    }, []);
  

  // ** Fetch RM Shortage Data **
  const fetchShortageData = useCallback(async () => {
    try {
      const response = await axiosInstance.get("/api/RMshortage");
      setShortageData(response.data);
    } catch (error) {
      console.error("Error fetching shortage data:", error);
    }
  }, []);

  useEffect(() => {
    fetchShortageData();
  }, [fetchShortageData]);

  // ** Function to filter table data **
  const filteredData = shortageData.filter((row) =>
    row["KD_CODE"].toLowerCase().includes(searchTerm)
  );

    // ** Run Session Check & Fetch Data **
    useEffect(() => {
      checkAuth(); // Initial session check
      fetchShortageData(); // Fetch data
  
      const interval = setInterval(checkAuth, 1000); // Check session every second
      return () => clearInterval(interval); // Cleanup on component unmount
    }, [checkAuth, fetchShortageData]);


    const handleDoneClick = async (kd_code) => {
      try {
        await axiosInstance.patch("/api/update-PO-status", {
          KD_CODE: kd_code,
          poStatus: "PO Raised Confirm",
        });
    
        alert(`PO Raised status updated for ${kd_code}`);
        fetchShortageData(); // Refresh table data
      } catch (error) {
        console.error("Failed to update PO status:", error);
        alert("Error updating PO status");
      }
    };

  // ** Define Table Columns **
  const columns = [
    // { name: "Sr No", selector: (_, index) => index + 1, sortable: true, width: "80px" },
    { 
      name: "Item Discription", 
      selector: (row) =>  (
        <span
        data-toggle="tooltip"
        title={row.Iteam}
        >
          {row.Iteam}
        </span>
      ), 
      sortable: true 
    },
    { name: "Item Name", selector: (row) => (
      <span
      data-toggle="tooltip"
      title={row.Item_Name}
      >
        {row.KD_CODE || "N/A"}
      </span>
    ), sortable: true },  
    { 
      name: "RM Item Code", 
      selector: (row) => row.Rm_Item_Code || "N/A", 
      sortable: true 
    },
   
    { 
      name: "Unit", 
      selector: (row) => (
        <span
        data-toggle="tooltip"
        title={row.Unit}
        >
          {row.Unit || "N/A"}
        </span>
      ), 
      sortable: true 
    },
    { 
      name: "Plan Qty", 
      selector: (row) => row.Plan_Qty, 
      sortable: true,
      cell: (row) => (
        <span style={{ 
          color: row.Is_Highlighted === 1 && row.PO_STATUS !== "PO Raised Confirm" ? "red" : "black", // 🔴 Red only if NOT PO Raised
          fontWeight: row.Is_Highlighted === 1 ? "bold" : "normal" 
        }}>
          {row.Total_Plan_Qty || "N/A"}
        </span>
      )
    },
    { 
      name: "PO Numbers", 
      selector: (row) => row.PO_Numbers || "N/A", 
      sortable: true 
    },
    { 
      name: "PO Status", 
      selector: (row) => row.PO_STATUS || "N/A", 
      sortable: true 
    },
    { 
      name: "STOCK IN HAND", 
      selector: (row) => row.Total_Stock_In_Hand || 0, 
      sortable: true 
    },
   
    {
      name: "Action",
      cell: (row) => {
        const isRaised = row.PORaised_Time !== null;
    
        return  (
          <button
            className="btn btn-success btn-sm"
            onClick={() => !isRaised && handleDoneClick(row.KD_CODE)}
            style={{
              cursor: isRaised ? "not-allowed" : "pointer",
              opacity: isRaised ? 0.8 : 1,
              pointerEvents: isRaised ? "auto" : "auto", // Keep hover effect
            }}
            title={isRaised ? "Already PO Raised" : "Mark as Done"}
           >
            {isRaised ? "PO Raised" : "Pending"}
          </button>
        ) ;
      },
      ignoreRowClick: true,
      allowOverflow: true,
      button: true
    }
  ];
 // ** Conditional Row Styling (Make whole row red if `Is_Highlighted = 1`) **
// ** Conditional Row Styling **
const conditionalRowStyles = [
  {
    when: (row) => row.PO_STATUS === "PO Raised Confirm", // ✅ Green if PO Raised
    style: {
      backgroundColor: "#ccffcc", // Light green background
      color: "black", 
      fontWeight: "bold",
    },
  },
  {
    when: (row) => row.Is_Highlighted === 1 && row.PO_STATUS !== "PO Raised Confirm", // ✅ Red only if NOT PO Raised
    style: {
      backgroundColor: "#ffcccc", // Light red background
      color: "black",
      fontWeight: "bold",
    },
  },
];

  return (
    <>
      <WIPHeader />
      <div className="p-4">
        <h1 className=" mb-4">RM Shortage</h1>

        <div className="d-flex justify-content-between align-items-center mb-3">
          <button className="btn btn-secondary btn-sm" onClick={() => window.history.back()}>
            &#8592; Back
          </button>
          <input
            type="text"
            className="form-control w-25"
            placeholder="Search Item Name"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        {/* ✅ DataTable Integration */}
        <DataTable
          columns={columns}
          data={filteredData}
          pagination
          highlightOnHover
          conditionalRowStyles={conditionalRowStyles}
        />
      </div>
    </>
  );
};

export default RMShortage;
